import React from "react";
import PricesTabsComponent from "./prices-tabs.component";

const PricesTabsContainer = ({ tabChanged }: any) => {
  return <PricesTabsComponent tabChanged={tabChanged} />;
};

export default PricesTabsContainer;
